import React from 'react';

var classNames = require('classnames');

export default class extends React.Component {

    constructor(props) {
        super(props);

        this.columns = [...this.props.columns];
        this.state = {};
        this.state.rows = [...this.props.rows];
        this.state.filter = '';
        this.state.rowFilter = null;
        this.state.rowOrder = null;
        this.state.rowSelection = {};

        this.state.sortOrder = undefined;
        this.state.sortBy = undefined;
        
        // Generate standard unsorted rowOrder
        this.state.rowOrder = this.props.rows.map((row, index) => {
            return index;
        });

        this.columns.forEach((column, index) => {

            if (column.selector == undefined && typeof column.id == 'string') {
                column.selector = (row) => {
                    return row[column.id];
                }
            }

            if (column.value == undefined) 
                column.value = column.selector;

            if (column.format == undefined)
                column.format = column.selector;

            if (column.content == undefined) {
                column.content = column.format;
            }


        });

           
    }

    debug() {
        console.log.apply(this, arguments);
    }

    foo() {
        console.log('this is foo');
    }
    renderRow(row, rowIndex) {

        let onClick = (event) => {
            let target = event.target;
            let index = target.parentNode.attributes['index'].value;
            let row = this.props.rows[index];

            let rowSelection = this.state.rowSelection;

            switch(this.props.selectionStyle) {
                case 'multiple': {
                    if (rowSelection[index])
                        delete rowSelection[index];
                    else
                        rowSelection[index] = row;
                    break;
                }
                case 'single': {
                    rowSelection = {};
                    rowSelection[index] = row;
                    break;
                }

            }

            if (typeof this.props.onSelectionChange == 'function') {
                let selectedRows = [];
                
                for (let key in rowSelection) {
                    selectedRows.push(this.props.rows[key]);
                }

                this.props.onSelectionChange(selectedRows);
            }

            this.setState({rowSelection:rowSelection});
        };

        let items = this.columns.map((column, columnIndex) => {

            var {id, className, align = 'left', content} = column;

            className = classNames(className, 'align-middle');

            if (align === 'right')
                className = classNames(className, 'text-end');

            if (align === 'center')
                className = classNames(className, 'text-center');

            if (align === 'left')
                className = classNames(className, 'text-start');

            if (content == undefined) {
                content = row[id] == undefined ? '-' : row[id];
            }
            else if (typeof content === 'function')
                content = content(row, rowIndex);


            if (content == undefined)
                content = row[id];


            return (
                <td key={columnIndex} className={className}>
                    {content}
                </td>
            );
        });

        let className = '';

        if (this.state.rowSelection[rowIndex])
            className = classNames(className, 'table-primary ');

        return (
            <tr key={rowIndex} className={className} index={rowIndex} onClick={onClick}>
                {items}
            </tr>
        );
    }

    renderColumns() {

        let onColumnClick = (event) => {

            let index = event.target.attributes['index'].value;

            if (this.columns[index] != undefined) {
                let column = this.columns[index];
    
                if (column.selector) {
    
                    let rows = this.props.rows;
                    let sortOrder = this.state.sortOrder;
                    let sortBy = this.state.sortBy;
                    let rowOrder = this.state.rowOrder;
    
                    if (sortOrder == 'ascending' || sortBy != index) {
                        rowOrder = rowOrder.sort((a, b) => {
                            let rowA = rows[a];
                            let rowB = rows[b];
                            return column.selector(rowA) > column.selector(rowB);
                        });
    
                        sortOrder = 'descending';
                    }
                    else {
                        rowOrder = rowOrder.sort((a, b) => {
                            let rowA = rows[a];
                            let rowB = rows[b];
                            return column.selector(rowA) < column.selector(rowB);
                        });
    
                        sortOrder = 'ascending';
    
                    }
    
                    this.setState({rowOrder:rowOrder, sortBy:index, sortOrder:sortOrder});
                }
            }            
        }


        let items = this.columns.map((column, index) => {

            var {format, className, align, title, content, ...options} = column || {}

            className = classNames(className, 'align-middle');

            if (align === 'right')
                className = classNames(className, 'text-end');

            if (align === 'center')
                className = classNames(className, 'text-center');

            if (align === 'left')
                className = classNames(className, 'text-start');

            className = classNames(className, 'text-muted');

            if (typeof title == 'function')
                title = title(column, index);

            if (title == undefined)
                title = column;

            if (this.state.sortBy == index) {
                if (this.state.sortOrder == 'ascending')
                    title += ' ▼';
                    
                if (this.state.sortOrder == 'descending')
                    title += ' ▲';
            }

            return (
                <th key={index} index={index} className={className} onClick={onColumnClick}>{title}</th>
            );
        });


        return (
            <tr>
                {items}    
            </tr>
        );
    }


    renderHeader() {
        return (
            <thead style={{fontSize:'85%'}} >
                {this.renderColumns()}
            </thead>
        );
    }

    renderBody() {

        let items = this.props.rows.map((row, index) => {
            // Translate the row index accordning to sorting
            index = this.state.rowOrder[index];

            if (!this.state.rowFilter || this.state.rowFilter[index])
                return this.renderRow(this.props.rows[index], index);
        });

        return (
            <tbody>
                {items}
            </tbody>

        );


    }


    renderFilter() {


        let onChange = (event) => {
            let filter = event.target.value;
            let rowFilter = filter == '' ? null : filterRows(event.target.value);

            this.setState({rowFilter:rowFilter, filter:filter});
        }


        let filterRows = (filter) => {

            let rows = this.props.rows;

            filter = filter.toUpperCase();

            if (filter == '')
                return null;

            let filterRow = (row) => {

                if (filter == '')
                    return row;

                for (let column of this.columns) {
                    if (column.format) {
                        let value = column.format(row);
                        if (value) {
                            let text = value.toString();
                            if (text.toUpperCase().includes(filter))
                                return row;
    
                        }
                    }
                }
    
            };

            let rowFilter = {};

            rows.forEach((row, index) => {
                if (filterRow(row))
                    rowFilter[index] = row;

            })

            return rowFilter;
        }

        return (
            <div >
                <input style={{fontSize:'90%'}} className="form-control" placeholder="Snabbfilter" value={this.state.filter} onChange={onChange}></input>
            </div>

        );        
    }


    render() {
        return (
            <div>
                {this.renderFilter()}
                <table className='table  table-responsive table-hover' style={{cursor:'default'}} >
                    {this.renderHeader()}
                    {this.renderBody()}
                </table>
            </div>
        );
    }
    

}
